module.exports = __webpack_public_path__ + "img/logo-megabonus-main.2373140d.svg";